import React, { useEffect, useRef, useState } from "react";
import { useSelector } from 'react-redux';
import { Col, Divider, Grid, Row, } from 'rsuite';


function Catalog({ articulos, groupType, headerText, httpOnly, proyectUser, validityTo, asSearchView }) {
    const site = useSelector(state => state.site);
    const imagePerPage = useRef(12);
    const [pages, setPages] = useState(null);

    const Folder = (type, divider, pageID) => {
        return (
            <>
                <div className="pdf-page" id={"page_" + pageID} key={"folder_" + pageID}>
                    <img src={`${site.site.apiServer}/catalogo/res/${type}`} alt="Cover" style={{ position: "absolute", left: 0, top: 0 }} />
                    {proyectUser.printUser && pageID > 1 && (
                        <div className="vendor-contact-data">
                            <div>{proyectUser.contactName}</div>
                            <div>{proyectUser.contactEmail}</div>
                            <div>{proyectUser.contactPhone}</div>
                        </div>
                    )}
                </div>
                {divider && (<Divider key={"divider_" + pageID} />)}
            </>
        );
    }
    const Page = (r, pageID, rows) => {
        return (
            <>
                <div className="pdf-page" id={"page_" + pageID} key={"page_" + pageID}>
                    <div className="pdf-page-header">
                        <div className="pdf-page-header-content">
                            <img src={`${site.site.apiServer}/catalogo/res/header`} alt="Header" style={{ position: "absolute", left: 0, top: 0 }} />
                            <div className="pdf-page-header-content-title">{r.name}</div>
                            <img src={`${site.site.apiServer}/catalogo/res/logo-header?id=${r.id}&type=${r.type}`} alt="Header Icon" className="pdf-page-header-content-logo"></img>
                            <div className="pdf-page-header-content-message">{headerText}</div>
                            <div className="pdf-page-header-content-validty">{validityTo}</div>
                        </div>
                    </div>
                    <Grid fluid>
                        {rows != null && rows.map((z, i) => { return z; })}
                    </Grid>
                </div>
                <Divider key={"divider_" + pageID} />
            </>
        )
    }
    const PageRow = (a, k, p, w) => {
        return (
            <Row gutter={20} key={'pageRow_' + p + '_' + k + '_' + w} style={{ margin: 0, padding: "0px 5px", minHeight: imagePerPage.current === 16 ? 236 : 290 }}>
                {a.map((item, key) => {
                    return (
                        <Col xs={6} key={'pageCol_' + p + '_' + k + '_' + w + '_col_' + key}>
                            <div className={'pdf-page-item-container' + (item.price <= 0 ? ' no-price' : '')} style={{ position: "relative" }}>
                                <img src={`${site.site.apiServer}/catalogo/res/item-background${item.price > 0 ? '' : '-noprice'}`} alt="ItemBK" style={{ position: "absolute", left: 0, top: 0 }} />
                                <div style={{ position: "absolute", left: 0, top: 0 }}>
                                    {item.price > 0 && (
                                        <div className="pdf-item-product">{item.label}</div>
                                    )}
                                    {item.price <= 0 && (
                                        <div className="pdf-item-product no-price" style={{ height: 0, paddingTop: 5}}></div>
                                    )}
                                    <div className="pdf-item-image-container">
                                        {!httpOnly && (
                                            <img
                                                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAXwBfAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCACWAJYDAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAr/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AL+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf//Z"
                                                data-src={`${site.site.apiServer}/articulo/${item.image}`} width="150" height="150" className="pdf-item-image" style={{ margin: "auto" }} alt="product" />
                                        )}
                                        {httpOnly && (
                                            <img src={`${site.site.apiServer}/articulo/${item.image}`} width="150" height="150" className="pdf-item-image" style={{ margin: "auto" }} alt="product" loading="lazy" />
                                        )}
                                    </div>
                                    <div className={'pdf-item-product-code'}>cod. {item.value}</div>
                                    {item.price > 0 && (
                                        <div className="pdf-item-price">
                                            <h1>{site.site.decimalPlaces === 0 ? new Intl.NumberFormat('es-AR', {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            }).format(item.price) : (Math.round(item.price * 100) / 100).toFixed(site.site.decimalPlaces)}</h1>
                                            <h5>{item.priceBottom}</h5>
                                        </div>)
                                    }
                                    {item.price <= 0 && (
                                        <div className="pdf-item-product no-price">{item.label}</div>
                                    )}
                                </div>
                            </div>
                            
                        </Col>
                    )
                })}
            </Row>
        )
    }
    
    const render = () => {
        let pages = [];
        let pageIndex = 0;
        let cover = asSearchView ? 0 : parseInt(site.site.covers);


        if ((cover & 1) == 1) {
            pages.push(Folder('cover', true, pageIndex));
            pageIndex++;
        }
        
        if ((cover & 2) == 2) {
            pages.push(Folder('cover-2', true, pageIndex));
            pageIndex++;
        }

        imagePerPage.current = articulos.every(i => i.price === 0) ? 16 : 12;
        let group = [];
        if (groupType === '0' || groupType === 0) {
            for (let i = 0; i < articulos.length; i++)
                if (group.length === 0 || !group.some(u => u.id === articulos[i].rubroID))
                    group.push({ id: articulos[i].rubroID, name: articulos[i].rubro.replace(articulos[i].rubroID, ''), type: 'rubro' });
            for (let r = 0; r < group.length; r++) {
                for (let i = 0; i < Math.ceil(articulos.filter(a => a.rubroID === group[r].id).length / imagePerPage.current); i++) {
                    pages.push(Page(group[r], pageIndex, renderRow(i, group[r], pageIndex)));
                    pageIndex++;
                }
            }
        }
        else if (groupType === '1' || groupType === 1) {
            for (let i = 0; i < articulos.length; i++)
                if (group.length === 0 || !group.some(u => u.id === articulos[i].subrubroID))
                    group.push({ id: articulos[i].subrubroID, name: articulos[i].subrubro.replace(articulos[i].subrubroID, ''), type: 'subrubro' });
            for (let r = 0; r < group.length; r++) {
                for (let i = 0; i < Math.ceil(articulos.filter(a => a.subrubroID === group[r].id).length / imagePerPage.current); i++) {
                    pages.push(Page(group[r], pageIndex, renderRow(i, group[r], pageIndex)));
                    pageIndex++;
                }
            }
        }

        if ((cover & 4) == 4) {
            pages.push(Folder('back-cover', false, pageIndex));
        }

        return pages;
    }
    const renderRow = (p, r, w) => {
        let rows = [];
        if (r.type === 'rubro')
            for (let i = p * imagePerPage.current; i < Math.min(articulos.filter(a => a.rubroID === r.id).length, (p * imagePerPage.current) + imagePerPage.current); i += 4)
                rows.push(PageRow(articulos.filter(a => a.rubroID === r.id).slice(i, i + 4), i, p, w));
        else if (r.type === 'subrubro')
            for (let i = p * imagePerPage.current; i < Math.min(articulos.filter(a => a.subrubroID === r.id).length, (p * imagePerPage.current) + imagePerPage.current); i += 4)
                rows.push(PageRow(articulos.filter(a => a.subrubroID === r.id).slice(i, i + 4), i, p, w));
        return rows;
    }

    useEffect(() => {
        console.log('Catalog component loaded');

        var head = document.head;

        var default_css = document.createElement("link");
        default_css.type = "text/css";
        default_css.rel = "stylesheet";
        default_css.href = "./defaultPage.css";

        var custom_css = document.createElement("link");
        custom_css.type = "text/css";
        custom_css.rel = "stylesheet";
        custom_css.href = `${site.site.apiServer}/catalogo/res/vc`;

        var fonts_css = document.createElement("link");
        fonts_css.type = "text/css";
        fonts_css.rel = "stylesheet";
        fonts_css.href = `${site.site.apiServer}/catalogo/res/fonts`;

        head.appendChild(default_css);

        if (asSearchView !== true) {
            head.appendChild(custom_css);
            head.appendChild(fonts_css);
        }

        //setPages(render);

        return () => {

            head.removeChild(default_css);
            if (asSearchView !== true) {
                head.removeChild(custom_css);
                head.removeChild(fonts_css);
            }
            console.log('Catalog component unloaded');
        }
    }, []);

    useEffect(() => {
        console.log('cambiamo');
        setPages(render);
    }, [articulos])

    return (
        <>
            {pages != null && pages.map((p, i) => { return <div key={"div_" + i}>{p}</div>; })}
        </>
    )

}
export default Catalog;